export enum ACCRUAL_TYPE_ENUM {
  NONE = 'NONE',
  PAYMENT_ADJUSTED = 'PAYMENT_ADJUSTED',
  PAYMENT_UNADJUSTED = 'PAYMENT_UNADJUSTED',
  OBS_UNADJUSTED = 'OBS_UNADJUSTED',
  ADJUSTED = 'ADJUSTED',
  UNADJUSTED = 'UNADJUSTED',
  OBS_ADJUSTED = 'OBS_ADJUSTED',
}
